const CART_RECOVERY_SYNC_ENABLED = true;
const CART_UPSELL_DISMISSED_STORAGE_KEY = 'tsvite.cartUpsell.dismissed';
// Temporary recovery sync for stale mobile carts. Disable after September 7, 2026 if the incident is resolved.

let cartPopupSyncRequest = null;
let cartPopupMutationInProgress = false;

window.addEventListener("load", function () {
  const cartPopup = document.getElementById('cart-popup');
  const iconCartPopup = document.getElementById('cart-link');

  if (iconCartPopup && cartPopup) {
    updateCartBuble();
    bindCartPopupControls();
    bindDismissibleCartUpsells();
    bindCartPopupOpenSync(iconCartPopup, cartPopup);
    bindCartPopupCheckoutGuard();

    if (CART_RECOVERY_SYNC_ENABLED) {
      syncCartState('load');
    }
  }

  const main = document.querySelector('.main');
  if (main && cartPopup && !main.dataset.cartPopupOutsideClickBound) {
    main.dataset.cartPopupOutsideClickBound = 'true';
    main.addEventListener('click', function (e) {
      if (!e.target.closest('#cart-popup') && cartPopup.classList.contains('open') && !cartPopup.classList.contains('loading')) {
        cartPopup.classList.remove('open');
      }
    });
  }
});

if (CART_RECOVERY_SYNC_ENABLED) {
  window.addEventListener('pageshow', function () {
    syncCartState('pageshow');
  });

  window.addEventListener('focus', function () {
    syncCartState('focus');
  });
}

function storeUrl(path) {
  if (/^https?:\/\//i.test(path)) return path;

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const shopUrl = new URL(window.shopUrl || window.location.origin, window.location.origin);
  const rootPath = shopUrl.pathname.replace(/\/$/, '');

  if (rootPath && (normalizedPath === rootPath || normalizedPath.startsWith(`${rootPath}/`))) {
    return `${shopUrl.origin}${normalizedPath}`;
  }

  return `${shopUrl.origin}${rootPath}${normalizedPath}`;
}

function fetchCartJson() {
  return fetch(storeUrl('/cart.js'), {
    cache: 'no-store',
    credentials: 'same-origin'
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`Unable to fetch cart: ${response.status}`);
    }

    return response.json();
  });
}

function formatCartMoney(cents) {
  const amount = Number(cents || 0) / 100;
  if (Number.isInteger(amount)) {
    return String(amount);
  }

  return amount.toFixed(2).replace(/\.00$/, '');
}

function getCartCurrencyLabel(cart) {
  return cart?.currency || window.currency_ || 'UAH';
}

function setCartCounter(itemCount) {
  const countElement = document.querySelector(".cart-counter .count");
  if (countElement) {
    countElement.textContent = itemCount;
  }
}

function updateCartDrawerState(cart) {
  const cartPopup = document.querySelector('#cart-popup');
  if (!cartPopup || !cart) return;

  const isEmpty = cart.item_count === 0;
  const emptyState = cartPopup.querySelector('.cart-empty');
  const products = cartPopup.querySelector('.cart-popup-products');
  const productsWrap = cartPopup.querySelector('.cart-popup-products-wrap');
  const upsells = cartPopup.querySelectorAll('.cart-upsell');
  const footer = cartPopup.querySelector('.cart-popup-footer');
  const total = cartPopup.querySelector('.cart-popup-total-price');

  setCartCounter(cart.item_count);

  if (emptyState) emptyState.classList.toggle('d-none', !isEmpty);
  if (products) products.classList.toggle('d-none', isEmpty);
  upsells.forEach((upsell) => upsell.classList.toggle('d-none', isEmpty));
  if (!isEmpty) {
    applyCartUpsellDismissal(cartPopup);
    if (typeof applyCartCompleteLookDismissal === 'function') {
      applyCartCompleteLookDismissal(cartPopup);
    }
  }
  if (footer) footer.classList.toggle('d-none', isEmpty);

  if (isEmpty && productsWrap) {
    productsWrap.innerHTML = '';
  }

  if (total) {
    const subtotal = cart.items_subtotal_price ?? cart.total_price ?? 0;
    total.dataset.basePrice = formatCartMoney(subtotal);
    total.textContent = `${formatCartMoney(subtotal)} ${getCartCurrencyLabel(cart)}`;
  }

  if (window.enabledCurrencySelector && typeof updatePrices === 'function') {
    updatePrices();
  }
}

function cartDrawerNeedsRender(cart) {
  const cartPopup = document.querySelector('#cart-popup');
  if (!cartPopup || !cart) return false;

  const drawerLineItems = Array.from(document.querySelectorAll('#cart-popup .cart-popup-products-wrap > .cart-popup-product'));
  const drawerLineItemCount = drawerLineItems.length;
  const actualLineItemCount = Array.isArray(cart.items) ? cart.items.length : 0;
  const emptyState = cartPopup.querySelector('.cart-empty');
  const footer = cartPopup.querySelector('.cart-popup-footer');

  if (drawerLineItemCount !== actualLineItemCount) return true;
  if (Array.isArray(cart.items)) {
    const hasDifferentLineItem = cart.items.some((item, index) => {
      const drawerItem = drawerLineItems[index];
      const drawerQuantity = Number(drawerItem?.querySelector('.quantity input')?.value);

      return drawerItem?.dataset.key !== item.key || drawerQuantity !== item.quantity;
    });

    if (hasDifferentLineItem) return true;
  }
  if (cart.item_count > 0 && emptyState && !emptyState.classList.contains('d-none')) return true;
  if (cart.item_count > 0 && footer && footer.classList.contains('d-none')) return true;

  return false;
}

function syncCartState(reason) {
  if (cartPopupMutationInProgress) {
    return Promise.resolve(null);
  }

  if (cartPopupSyncRequest) {
    return cartPopupSyncRequest;
  }

  cartPopupSyncRequest = fetchCartJson()
    .then((cart) => {
      if (cartDrawerNeedsRender(cart)) {
        return renderCart().then(() => {
          updateCartDrawerState(cart);
          return cart;
        });
      }

      updateCartDrawerState(cart);
      return cart;
    })
    .catch((err) => {
      console.error(`Unable to sync cart state (${reason}).`, err);
      return null;
    })
    .finally(() => {
      cartPopupSyncRequest = null;
    });

  return cartPopupSyncRequest;
}

function updateCartItemsCount(cartOverride) {
  const cartPromise = cartOverride ? Promise.resolve(cartOverride) : fetchCartJson();

  return cartPromise
    .then((cart) => {
      setCartCounter(cart.item_count);
      return cart;
    })
    .catch((err) => console.error("Error fetching cart count:", err));
}

function openCartPopup() {
  return renderCart().then(() => {
    document.querySelector('#cart-link')?.click();
  });
}

function updateCartBuble() {
  return updateCartItemsCount();
}

function updateCart(id, q, item) {
  const cartPopup = document.querySelector('#cart-popup');
  const key = item?.dataset?.key;

  if (!key) return Promise.resolve(null);

  const previousValue = item.closest('.cart-popup-product')?.querySelector('.quantity input')?.dataset.qu;
  const data = {
    id: key,
    quantity: q
  };

  cartPopup?.classList.add('loading');
  cartPopupMutationInProgress = true;

  return fetch(storeUrl(`${window.routes.cart_change_url}.js`), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify(data)
  })
    .then((response) => response.json().then((cart) => {
      if (!response.ok || cart.status >= 400) {
        const message = cart.description || cart.message || cart.error || 'Cart update failed.';
        throw new Error(message);
      }

      return cart;
    }))
    .then((cart) => {
      updateCartItemsCount(cart);
      return renderCart().then(() => {
        updateCartDrawerState(cart);
        return cart;
      });
    })
    .catch((error) => {
      console.error('Error updating cart:', error);

      const product = item.closest('.cart-popup-product');
      const quantityInput = product?.querySelector('.quantity input');
      const errorEl = product?.querySelector('.error-quantity');

      if (quantityInput && previousValue) {
        quantityInput.value = previousValue;
      }
      if (errorEl && Number(q) > Number(previousValue || 0)) {
        errorEl.classList.remove('d-none');
      }

      return syncCartState('update-error');
    })
    .finally(() => {
      cartPopupMutationInProgress = false;
      cartPopup?.classList.remove('loading');
    });
}

function bindCartPopupOpenSync(iconCartPopup, cartPopup) {
  if (iconCartPopup.dataset.cartPopupOpenSyncBound) return;

  iconCartPopup.dataset.cartPopupOpenSyncBound = 'true';
  iconCartPopup.addEventListener('click', function () {
    bindCartPopupControls();

    if (!cartPopup.classList.contains('open')) {
      syncCartState('drawer-open');
    }
  });
}

function bindCartPopupControls() {
  initCartPopup();
  switcherInputQuantityC();
  applyCartUpsellDismissal();
  bindCartPopupCheckoutGuard();
}

function getCartUpsellDismissed() {
  try {
    return window.sessionStorage?.getItem(CART_UPSELL_DISMISSED_STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
}

function setCartUpsellDismissed() {
  try {
    window.sessionStorage?.setItem(CART_UPSELL_DISMISSED_STORAGE_KEY, 'true');
  } catch (error) {
    // Ignore storage errors; the current DOM can still be dismissed.
  }
}

function applyCartUpsellDismissal(root = document) {
  const isDismissed = getCartUpsellDismissed();
  root.querySelectorAll('[data-cart-upsell-dismissible]').forEach((upsell) => {
    upsell.classList.toggle('d-none', isDismissed);
  });
}

window.applyCartUpsellDismissal = applyCartUpsellDismissal;

function bindDismissibleCartUpsells() {
  if (document.documentElement.dataset.cartUpsellDismissBound) return;

  document.documentElement.dataset.cartUpsellDismissBound = 'true';
  document.addEventListener('click', function (event) {
    const dismissButton = event.target.closest('[data-cart-upsell-dismiss]');
    if (!dismissButton) return;

    const upsell = dismissButton.closest('[data-cart-upsell-dismissible]');
    setCartUpsellDismissed();
    upsell?.classList.add('d-none');
  });
}

function initCartPopup() {
  const cartPopup = document.getElementById('cart-popup');
  if (!cartPopup) return;

  cartPopup.querySelectorAll('.cart-popup-product .cart-popup-product-remove-btn button').forEach((item) => {
    if (item.dataset.cartRemoveBound) return;

    item.dataset.cartRemoveBound = 'true';
    item.addEventListener('click', function () {
      updateCart(item.dataset.varid, 0, item);
    });
  });

  removeBtncartPopUp();
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}

function renderCart() {
  const cartPopup = document.querySelector('#cart-popup');
  if (cartPopup) {
    cartPopup.classList.add('loading');
  }

  return fetch(storeUrl('/cart'), {
    cache: 'no-store',
    credentials: 'same-origin'
  }).then(function (response) {
    if (!response.ok) {
      throw new Error(`Unable to render cart: ${response.status}`);
    }
    return response.text();
  }).then(function (responseText) {
    const doc = new DOMParser().parseFromString(responseText, 'text/html');
    const fetchCartPopup = doc.querySelector('#cart-popup');
    const currentCartPopup = document.querySelector('#cart-popup');

    if (!fetchCartPopup || !currentCartPopup) {
      throw new Error('Cart drawer markup was not found.');
    }

    currentCartPopup.innerHTML = fetchCartPopup.innerHTML;
    bindCartPopupControls();
    if (typeof initCartCompleteLookRails === 'function') {
      initCartCompleteLookRails(currentCartPopup);
    }

    if (window.enabledCurrencySelector && typeof updatePrices === 'function') {
      updatePrices();
    }

    currentCartPopup.classList.remove('loading');
    return true;
  }).catch(function (err) {
    console.error('Something went wrong.', err);
    document.querySelector('#cart-popup')?.classList.remove('loading');
    return false;
  });
}

function removeBtncartPopUp() {
  const cartPopUpElement = document.getElementById("cart-popup");
  const closeCartPopUpBtn = document.getElementById("close-cart-popup");
  const elMain = document.getElementsByClassName("main");

  if (closeCartPopUpBtn && !closeCartPopUpBtn.dataset.cartCloseBound) {
    closeCartPopUpBtn.dataset.cartCloseBound = 'true';
    closeCartPopUpBtn.addEventListener("click", function () {
      cartPopUpElement.classList.remove("open");
      if (elMain.length > 0) {
        elMain[0].classList.remove("no-overflow");
      }
    });
  }
}

function bindCartPopupCheckoutGuard() {
  const cartPopup = document.querySelector('#cart-popup');
  if (!cartPopup || cartPopup.dataset.checkoutGuardBound) return;

  cartPopup.dataset.checkoutGuardBound = 'true';

  document.addEventListener('click', function (event) {
    const checkoutTrigger = event.target.closest('#cart-popup .cart-popup-buy a[href], #cart-popup button[name="checkout"], #cart-popup .bss-checkout');
    if (!checkoutTrigger) return;

    if (checkoutTrigger.dataset.cartCheckoutGuardReady === 'true') {
      delete checkoutTrigger.dataset.cartCheckoutGuardReady;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    cartPopup.classList.add('loading');

    syncCartState('checkout-click').then((cart) => {
      if (!cart || cart.item_count === 0) {
        updateCartDrawerState(cart || { item_count: 0, items: [], items_subtotal_price: 0, total_price: 0 });
        return;
      }

      const currentTrigger = document.querySelector('#cart-popup .cart-popup-buy a[href], #cart-popup button[name="checkout"], #cart-popup .bss-checkout') || checkoutTrigger;
      currentTrigger.dataset.cartCheckoutGuardReady = 'true';
      currentTrigger.click();
    }).finally(() => {
      cartPopup.classList.remove('loading');
    });
  }, true);

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('#cart-popup .cart-popup-buy form, #cart-popup form[action*="/checkout"]');
    if (!form) return;

    if (form.dataset.cartCheckoutGuardReady === 'true') {
      delete form.dataset.cartCheckoutGuardReady;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    cartPopup.classList.add('loading');

    syncCartState('checkout-submit').then((cart) => {
      if (!cart || cart.item_count === 0) {
        updateCartDrawerState(cart || { item_count: 0, items: [], items_subtotal_price: 0, total_price: 0 });
        return;
      }

      const currentForm = document.querySelector('#cart-popup .cart-popup-buy form, #cart-popup form[action*="/checkout"]') || form;
      currentForm.dataset.cartCheckoutGuardReady = 'true';
      if (typeof currentForm.requestSubmit === 'function') {
        currentForm.requestSubmit();
      } else {
        currentForm.submit();
      }
    }).finally(() => {
      cartPopup.classList.remove('loading');
    });
  }, true);
}

function switcherInputQuantityC() {
  const quantityContainers = document.querySelectorAll("#cart-popup .quantity");
  quantityContainers.forEach(function (quantityContainer) {
    if (quantityContainer.dataset.quantityBound) return;

    const minusBtn = quantityContainer.querySelector(".minus");
    const plusBtn = quantityContainer.querySelector(".plus");
    const inputBox = quantityContainer.querySelector(".input-box");
    const errorEl = quantityContainer.closest('.cart-popup-product')?.querySelector('.error-quantity');
    const cartPopup = document.querySelector('#cart-popup');

    if (!minusBtn || !plusBtn || !inputBox) return;

    let lastTouchTime = 0;
    quantityContainer.dataset.quantityBound = 'true';
    updateButtonStates(inputBox, minusBtn, plusBtn);
    quantityContainer.addEventListener("click", handleButtonClick);
    quantityContainer.addEventListener("touchend", handleButtonTouchEnd);
    inputBox.addEventListener("input", handleQuantityChange);

    function updateButtonStates(inputBox, minusBtn, plusBtn) {
      const value = parseInt(inputBox.value);
      minusBtn.disabled = value <= 1;
      plusBtn.disabled = value >= parseInt(inputBox.max);
    }

    function handleButtonClick(event) {
      if (Date.now() - lastTouchTime < 700) return;

      if (event.target.classList.contains("minus")) {
        event.preventDefault();
        decreaseValue();
      } else if (event.target.classList.contains("plus")) {
        event.preventDefault();
        increaseValue();
      }
    }

    function handleButtonTouchEnd(event) {
      if (!event.target.classList.contains("minus") && !event.target.classList.contains("plus")) return;

      lastTouchTime = Date.now();
      event.preventDefault();
      if (event.target.classList.contains("minus")) {
        decreaseValue();
      } else {
        increaseValue();
      }
    }

    function decreaseValue() {
      let value = parseInt(inputBox.value) || 1;
      const errorMessageProduct = document.querySelector('.product-form__error-message-wrapper');
      const min = 1;

      if (value <= min) return;

      value = Math.max(value - 1, min);
      inputBox.value = value;
      updateButtonStates(inputBox, minusBtn, plusBtn);
      errorEl?.classList.add('d-none');

      cartPopup?.classList.add('loading');
      updateCart(inputBox.dataset.varid, value, minusBtn);
      errorMessageProduct?.classList.add('d-none');
    }

    function increaseValue() {
      let value = parseInt(inputBox.value) || 1;
      const max = parseInt(inputBox.dataset.maxValue) || Infinity;

      if (value >= max) {
        errorEl?.classList.remove('d-none');
        return;
      }

      value = Math.min(value + 1, max);
      inputBox.value = value;
      updateButtonStates(inputBox, minusBtn, plusBtn);
      errorEl?.classList.add('d-none');

      cartPopup?.classList.add('loading');
      updateCart(inputBox.dataset.varid, value, plusBtn);
    }

    function handleQuantityChange() {
      let value = parseInt(inputBox.value);
      value = isNaN(value) ? 1 : value;
      inputBox.value = value;
    }
  });
}
